/**
 * Escape the Frame — interactive escape-room experience
 *
 * ASSETS
 *   Room backgrounds: src/assets/room1.png, room2.png, room3.png
 *   To swap images update the imports in src/components/escape/rooms.ts
 *
 * HOTSPOT POSITIONS
 *   Defined as percent-based rects (xPct, yPct, wPct, hPct) in rooms.ts.
 *   Adjust those values to match your room image compositions.
 *
 * PERSISTENCE
 *   localStorage key: "nob_escape_v1"
 *   Stores: started, currentRoomIndex, completedRooms, finished, roomState
 *   Reset via the "Reset Run" button or localStorage.removeItem("nob_escape_v1")
 */
import { EscapeRoomShell } from '../components/escape/EscapeRoomShell';

export function ExperienceEscapeRoomPage() {
  return <EscapeRoomShell />;
}
